import cx from 'classix';
import { ReactNode } from 'react';

const ContentPanel = ({
  background = 'white',
  noTopPadding = false,
  noBottomPadding = false,
  children,
}: {
  background?: 'white' | 'light-gray' | 'dark-gray';
  noTopPadding?: boolean;
  noBottomPadding?: boolean;
  children: ReactNode;
}) => {
  return (
    <div
      className={cx(
        'text-gray-600 px-4 sm:px-8',
        background === 'white' && 'bg-white',
        background === 'light-gray' && 'bg-gray-50',
        background === 'dark-gray' && 'bg-gray-950',
        noTopPadding ? 'pt-0 sm:pt-0' : 'pt-10 sm:pt-20',
        noBottomPadding ? 'pb-0 sm:pb-0' : 'pb-16 sm:pb-20',
        background === 'dark-gray' && 'text-white',
      )}
    >
      <div className='max-w-[1216px] mx-auto'>{children}</div>
    </div>
  );
};

export default ContentPanel;
